import { FunctionComponent } from 'react';
import { Typography } from 'aqui';
import { PlusIcon } from 'aqui/icons';
import { t } from 'i18next';
import { useStartNewSession, useThreadsHandling } from '../../AppContext';
import useAnalytics from '../../hooks/useAnalytics';
import { ANALYTICS_EVENTS } from '../../consts';

const NewChatButton: FunctionComponent = () => {
    const { startNewSession } = useStartNewSession();
    const { isChatHistoryLoaded } = useThreadsHandling();

    const { sendEvent } = useAnalytics();
    const handleClick = () => {
        if (!isChatHistoryLoaded) {
            return;
        }
        startNewSession();
        sendEvent(ANALYTICS_EVENTS.NEW_CHAT_CLICK);
    };

    return (
        <div
            className={`main-header__new-chat-button flex align-center ${
                !isChatHistoryLoaded ? '--disabled' : ''
            }`}
            data-testid="new-chat-button"
            data-disabled={!isChatHistoryLoaded}
            onClick={handleClick}
        >
            <PlusIcon />
            <Typography type="small1">{t('chat.new-chat')}</Typography>
        </div>
    );
};

export default NewChatButton;
